export default "__VITE_ASSET__7J1qUo7g__"